var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Select } from '@ngxs/store';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { Observable, Subject, combineLatest } from 'rxjs';
import { ViewService } from '../../view.service';
import { LayoutService } from '../../layout.service';
import { ViewLayout } from '../../models/view-layout.enum';
import { takeUntil } from 'rxjs/operators';
export class ViewScenePaginationComponent {
    // ---------- Lifecycle Events ----------
    constructor(viewService, layoutService, changeDetectorRef) {
        this.viewService = viewService;
        this.layoutService = layoutService;
        this.changeDetectorRef = changeDetectorRef;
        // ---------- Class Variables ----------
        this.viewLayout = ViewLayout;
        this.nextChapterLabel = '';
        this.previousChapterLabel = '';
        this.ngUnsubscribe = new Subject();
    }
    ngOnInit() {
        combineLatest(this.chapterIndex$, this.chapterCount$).pipe(takeUntil(this.ngUnsubscribe)).subscribe(([index, count]) => {
            const previous = index > 0 ? index : 1;
            const next = index + 2 > count ? count : index + 2;
            this.nextChapterLabel = `Next Chapter (${next} of ${count})`;
            this.previousChapterLabel = `Previous Chapter (${previous} of ${count})`;
            this.changeDetectorRef.markForCheck();
        });
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    isEnabled(layout) {
        return this.layoutService.isLayoutEnabled(layout);
    }
    // ---------- Interactions ----------
    handleNextChapter() {
        this.viewService.nextChapter();
    }
    handlePreviousChapter() {
        this.viewService.previousChapter();
    }
}
__decorate([
    Select(StoryChaptersState.getSelectedChapterIndex),
    __metadata("design:type", Observable)
], ViewScenePaginationComponent.prototype, "chapterIndex$", void 0);
__decorate([
    Select(StoryChaptersState.getChapterCount),
    __metadata("design:type", Observable)
], ViewScenePaginationComponent.prototype, "chapterCount$", void 0);
